import type { Event } from 'models';
import { EventHeaderCanceled } from './event-header-canceled';
import { EventHeaderDefault } from './event-header-default';

type P = {
  event: Event;
  navigateToCalendar: () => void;
  navigateToEventDetail: (id: string) => Promise<void>;
};

const EventHeader = ({ event, navigateToCalendar, navigateToEventDetail }: P) => {
  const { status } = event;

  switch (status) {
    case 'active':
    case 'draft':
      return (
        <EventHeaderDefault
          event={event}
          navigateToCalendar={navigateToCalendar}
          navigateToEventDetail={navigateToEventDetail}
        />
      );
    case 'canceled':
      return <EventHeaderCanceled event={event} />;
  }
};

export default EventHeader;
